<template>
	<section>
		<bread-crumb></bread-crumb>
		<div class="notice-wrap">
           <h1>通知渠道</h1>
           <div @click="setCommon">
               <img src="../../assets/img/set.png">
               <span>默认</span>
           </div>
        </div>
        
        <div class="notice-list">
            <span>公众号通知</span>
            <el-switch  v-model="chatlVal"  disabled="disabled"  active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(chatlVal,"is_wechat_notice")'></el-switch>
            <span class="note">短信通知</span>
            <el-switch  v-model="noteVal"  active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(noteVal,"is_message_notice")'></el-switch>
        </div>
        
        <div class="order-notice">
            <h1>通知项目</h1>
            <div>
                <div class="notice-list first-wrap">
                    <span>下单完成通知</span>
                    <el-switch  v-model="placeOrderVal" active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(placeOrderVal,"is_order_notice")'></el-switch>
                    <span class="note">退款成功通知</span>
                    <el-switch  v-model="refundVal"  active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(refundVal,"is_refund_notice")'></el-switch>
                </div>
                
                <div class="notice-list">
                    <span>处理成功通知</span>
                    <el-switch  v-model="handelVal"  active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(handelVal,"is_handel_notice")'></el-switch>
                    <span class="note">未解决状态通知</span>
                    <el-switch  v-model="statusVal"  active-color="#FF8D1C"  inactive-color="#999999" @change='changeSwitch(statusVal,"is_unresolved_notice")'></el-switch>
                </div>
            </div>
        </div>
	</section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';	
import {userNoticeConfig,modifyUserNoticeConfig} from '@/api/personal';
export default {
    data() {
    	return {
            chatlVal:false,
            noteVal:true,
            placeOrderVal:true,
            refundVal:false,
            handelVal:true,
            statusVal:true,
            userId:""
		};
    },
    
    created(){
		this.getUserNoticeConfig();
    },
    
    methods:{
		async getUserNoticeConfig(){
		    const { status,data } = await userNoticeConfig();
		    if (status !== 200) return;
			this.chatlVal = data.is_wechat_notice == "1" ? false:true;
		    this.noteVal = data.is_message_notice == "1" ? false:true;
			this.placeOrderVal = data.is_order_notice == "1" ? false:true;
			this.refundVal = data.is_refund_notice == "1" ? false:true;
			this.handelVal = data.is_handel_notice == "1" ? false:true;
			this.statusVal = data.is_unresolved_notice == "1" ? false:true;
            this.userId =  data.user_uuid;
		},
        
		async changeSwitch(val,key){
            let postData = {
                is_wechat_notice:this.chatlVal==false?"1":"2",
                is_message_notice:this.noteVal==false?"1":"2",
                is_order_notice:this.placeOrderVal==false?"1":"2",
                is_refund_notice:this.refundVal==false?"1":"2",
                is_handel_notice:this.handelVal==false?"1":"2",
                is_unresolved_notice:this.statusVal==false?"1":"2"
            };
            postData[key] = val==true?"2":"1";
            const { status,data } = await modifyUserNoticeConfig(this.userId,postData);
            if (status == 200){
                if(data.success == "success"){
                    this.getUserNoticeConfig();
                    this.$message.success("修改成功")
                }
                else{
                    this.$message.error("系统繁忙，请稍后再试")
                }
            };
        },
        
		async setCommon(){
			let postData = {
			    is_wechat_notice:"2",
			    is_message_notice:"2",
			    is_order_notice:"2",
			    is_refund_notice:"2",
			    is_handel_notice:"2",
			    is_unresolved_notice:"1"
			};
			const { status,data } = await modifyUserNoticeConfig(this.userId,postData);
			if (status == 200){
			    if(data.success == "success"){
			        this.getUserNoticeConfig();
			        this.$message.success("重置成功")
			    }
			    else{
			        this.$message.error("系统繁忙，请稍后再试")
			    }
			};
		}
    },
	
	components: {
	    BreadCrumb
	}
};
</script>

<style lang="scss" scoped>
    h1{
        @include font-style;
        font-size: 20px;
        color: #000000;
    }
    .notice-wrap{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        margin-top: 30px;
        div{
            display: flex;
            align-items: center;
			@include cursor-style;
            img{
               width: 18px;
               height: 18px;
               margin-right: 10px;
            }
            span{
               @include font-style;
               font-size: 16px;
               color: #999999;
            } 
        }
        
    }
    .notice-list{
        display: flex;
        align-items: center;
        padding: 36px 0 36px 30px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.16);
        span{
            margin-right: 66px;
            width: 116px;
        }
        .note{
            margin-left: 322px;
        }
    }
    .order-notice{
        .notice-list:last-child{
            padding-top: 0;
        }
        .first-wrap{
            padding-bottom: 50px;
        }
        h1{
            margin: 30px 0;
        }
    }
</style>